import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Shield, Copy, Check } from 'lucide-react';
export function Setup2FAPage() {
  const [copied, setCopied] = useState(false);
  const handleCopy = () => {
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return <div className="min-h-screen bg-background flex items-center justify-center p-6" data-id="element-5752">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="w-full max-w-2xl" data-id="element-5753">
        <div className="flex flex-col items-center mb-8" data-id="element-5754">
          <Link to="/" className="flex items-center gap-2 mb-6" data-id="element-5755">
            <span className="text-2xl font-bold tracking-tight text-textMain" data-id="element-5756">
              Booker
            </span>
            <div className="w-2 h-2 rounded-full bg-primary mt-1" data-id="element-5757"></div>
          </Link>
          <h1 className="text-2xl font-bold text-textMain mb-2" data-id="element-5758">
            Secure your account
          </h1>
          <p className="text-textMuted text-sm text-center" data-id="element-5759">
            Set up two-factor authentication to add an extra layer of security.
          </p>
        </div>

        <div className="bg-surface border border-border rounded-xl p-8 shadow-xl" data-id="element-5760">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10" data-id="element-5761">
            {/* Left Col - QR Code */}
            <div data-id="element-5762">
              <div className="flex items-center gap-3 mb-4" data-id="element-5763">
                <div className="w-8 h-8 rounded-full bg-primary/20 flex items-center justify-center text-primary font-bold text-sm" data-id="element-5764">
                  1
                </div>
                <h3 className="font-semibold" data-id="element-5765">Scan QR Code</h3>
              </div>
              <p className="text-sm text-textMuted mb-6" data-id="element-5766">
                Scan this code with your authenticator app (like Google
                Authenticator or Authy).
              </p>
              <div className="bg-background border border-border rounded-xl p-4 flex items-center justify-center mb-4" data-id="element-5767">
                {/* Placeholder for actual QR code */}
                <div className="w-48 h-48 bg-white rounded flex items-center justify-center" data-id="element-5768">
                  <div className="w-40 h-40 border-4 border-black border-dashed flex items-center justify-center" data-id="element-5769">
                    <span className="text-black font-bold text-xs" data-id="element-5770">
                      QR CODE
                    </span>
                  </div>
                </div>
              </div>
              <div className="text-center" data-id="element-5771">
                <span className="text-xs text-textMuted" data-id="element-5772">
                  Can't scan? Use this setup key:
                </span>
                <div className="mt-1 font-mono text-sm tracking-wider bg-background border border-border py-1.5 px-3 rounded inline-block" data-id="element-5773">
                  JBSWY3DPEHPK3PXP
                </div>
              </div>
            </div>

            {/* Right Col - Backup & Verify */}
            <div className="flex flex-col" data-id="element-5774">
              <div className="flex items-center gap-3 mb-4" data-id="element-5775">
                <div className="w-8 h-8 rounded-full bg-primary/20 flex items-center justify-center text-primary font-bold text-sm" data-id="element-5776">
                  2
                </div>
                <h3 className="font-semibold" data-id="element-5777">Save Backup Codes</h3>
              </div>
              <p className="text-sm text-textMuted mb-4" data-id="element-5778">
                Save these codes in a secure place. You can use them to access
                your account if you lose your device.
              </p>

              <div className="bg-background border border-border rounded-lg p-4 mb-3" data-id="element-5779">
                <div className="grid grid-cols-2 gap-x-4 gap-y-2 font-mono text-sm tracking-wider text-textMain" data-id="element-5780">
                  <div data-id="element-5781">4829-1039</div>
                  <div data-id="element-5782">9283-4712</div>
                  <div data-id="element-5783">5738-9201</div>
                  <div data-id="element-5784">1029-3847</div>
                  <div data-id="element-5785">8472-9102</div>
                  <div data-id="element-5786">3948-5712</div>
                  <div data-id="element-5787">1928-3746</div>
                  <div data-id="element-5788">5647-3829</div>
                </div>
              </div>

              <button onClick={handleCopy} className="flex items-center justify-center gap-2 w-full py-2 bg-surface border border-border hover:bg-surfaceHover rounded-lg text-sm font-medium transition-colors mb-8" data-id="element-5789">
                {copied ? <Check className="w-4 h-4 text-green-500" data-id="element-5790" /> : <Copy className="w-4 h-4 text-textMuted" data-id="element-5791" />}
                {copied ? 'Copied!' : 'Copy codes'}
              </button>

              <div className="mt-auto" data-id="element-5792">
                <div className="flex items-center gap-3 mb-4" data-id="element-5793">
                  <div className="w-8 h-8 rounded-full bg-primary/20 flex items-center justify-center text-primary font-bold text-sm" data-id="element-5794">
                    3
                  </div>
                  <h3 className="font-semibold" data-id="element-5795">Verify & Enable</h3>
                </div>
                <div className="flex gap-3" data-id="element-5796">
                  <input type="text" maxLength={6} placeholder="000000" className="flex-1 px-4 py-2.5 bg-background border border-border rounded-lg text-center font-mono text-lg tracking-widest focus:outline-none focus:border-primary transition-colors" data-id="element-5797" />
                  <button className="px-6 py-2.5 bg-primary text-background rounded-lg font-medium hover:bg-primaryHover transition-colors shadow-[0_0_15px_rgba(245,158,11,0.2)]" data-id="element-5798">
                    Enable
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </div>;
}